import axios from 'axios'
import { logger } from '@/logger'

export const getMessages = (mainTheme) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/messages.json.php', { MainTheme: mainTheme })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(logger.error(error))
      })
  })
}

export const hideMessage = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/hide-message.json.php', { MessageID: id })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(logger.error(error))
      })
  })
}
